import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu } from 'lucide-react';

const navLinks = [
  { label: 'Product', href: '#problem' },
  { label: 'Capabilities', href: '#capabilities' },
  { label: 'Proof', href: '#proof' },
];

export default function Navbar({ variant = 'transparent' }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      data-testid="navbar"
      className="flex items-center justify-between h-14 w-full"
    >
      <a
        href="#"
        data-testid="navbar-brand"
        onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
        className="flex items-baseline gap-2"
      >
        <span className="font-display text-xl tracking-tight text-white">
          TenderAI
        </span>
      </a>

      <div className="hidden md:flex items-center gap-7">
        {navLinks.map((link) => (
          <button
            key={link.href}
            data-testid={`navbar-link-${link.label.toLowerCase()}`}
            onClick={() => scrollTo(link.href)}
            className="link-underline text-sm text-white/60 hover:text-white/90 transition-colors duration-200"
          >
            {link.label}
          </button>
        ))}
      </div>

      <div className="hidden md:flex items-center gap-3">
        <Button
          data-testid="navbar-join-waitlist-button"
          onClick={() => scrollTo('#waitlist')}
          className="bg-white text-[hsl(150,18%,18%)] hover:bg-white/90 h-9 px-5 text-sm font-medium rounded-full shadow-card"
        >
          Join Waitlist
        </Button>
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetTrigger asChild className="md:hidden">
          <button
            data-testid="navbar-mobile-menu-button"
            className="p-2 text-white/60 hover:text-white/90 transition-colors"
          >
            <Menu className="w-5 h-5" />
          </button>
        </SheetTrigger>
        <SheetContent side="right" className="bg-card border-border w-72">
          <div className="flex flex-col gap-1 mt-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-left px-4 py-3 text-base text-foreground/75 hover:text-foreground hover:bg-muted/50 rounded-lg transition-colors duration-200"
              >
                {link.label}
              </button>
            ))}
            <div className="mt-4 px-4">
              <Button
                onClick={() => scrollTo('#waitlist')}
                className="w-full btn-lift bg-foreground text-background hover:bg-foreground/90 h-11 rounded-full font-medium"
              >
                Join Waitlist
              </Button>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </nav>
  );
}
